import React, { useState } from "react";
import FooterLogo from "../assets/images/banner-logo.svg";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <div className="footer_parent">
        <div className="container">

          <div className="footer-logo">
            <a href="/">
              <img src={FooterLogo} alt="" />
            </a>
          </div>
          <div className="footer-content">
            <p>© 2025. Sumo Ordering. All rights reserved</p>
            <p>
              <Link
                to={"/terms"}
              >
                Terms of Use
              </Link>
              <span
              >
                {" "}
                •{" "}
              </span>
              <Link
                to={"/privacy"}
              >Privacy Policy</Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
